export const SET_CURRENCY_MARKET_LIST = 'SET_CURRENCY_MARKET_LIST'
export const GET_CURRENCY_MARKET_LIST = 'GET_CURRENCY_MARKET_LIST'
export const SET_CURRENCY_MARKET_LIST_LOADING = 'SET_CURRENCY_MARKET_LIST_LOADING'

export const SET_CURRENCY_MAP_MARKET_LIST = 'SET_CURRENCY_MAP_MARKET_LIST'

export const SET_INTERVAL_GRAPH_VALUE = 'SET_INTERVAL_GRAPH_VALUE'

// WEB SOCKET
export const WS_CONNECT_CURRENCY_MARKET = 'WS_CONNECT_CURRENCY_MARKET'
export const WS_DISCONNECT_CURRENCY_MARKET = 'WS_DISCONNECT_CURRENCY_MARKET'
export const WS_CURRENCY_MARKET_MESSAGE_RECEIVED = 'WS_CURRENCY_MARKET_MESSAGE_RECEIVED'
export const WS_ERROR_CURRENCY_MARKET = 'WS_ERROR_CURRENCY_MARKET'
export const WS_CURRENCY_MARKET_CHANGE_CURRENCY_VALUE = 'WS_CURRENCY_MARKET_CHANGE_CURRENCY_VALUE'

// NEW Accordion logic
export const SET_OPEN_ACCORDION_PANEL_GROUP_ID = 'SET_OPEN_ACCORDION_PANEL_GROUP_ID'
export const SET_OPEN_ACCORDION_PANEL_GROUP_LIST = 'SET_OPEN_ACCORDION_PANEL_GROUP_LIST'
export const SET_ACCORDION_TITLES_LIST = 'SET_ACCORDION_TITLES_LIST'
export const SET_CURRENT_ACTIVE_CURRENCY_INFO = 'SET_CURRENT_ACTIVE_CURRENCY_INFO'
export const WS_CURRENCY_MARKET_MESSAGE_RECEIVED_UPDATE_GLOBAL_LIST =
  'WS_CURRENCY_MARKET_MESSAGE_RECEIVED_UPDATE_GLOBAL_LIST'

export const SET_UPDATED_CURRENCIES_LIST = 'SET_UPDATED_CURRENCIES_LIST'
